import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/customer_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  keyword: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'name',
  },
  name_cont: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'name',
  },
  manager_cont: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'manager',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  user_id_in: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  user_id_null: {
    column_type: 'boolean',
    model_name: 'Customer',
    column_name: 'userId',
  },
  user_team_id_eq: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'userTeamIdEq',
  },
  customer_level_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_level: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_source_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_source: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_source_id_in: {
    column_type: 'belongs_to',
    column_name: 'customer_source',
    extra: {
      model_name: 'CustomerSource',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_kind_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_kind',
    extra: {
      model_name: 'CustomerKind',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_kind: {
    column_type: 'belongs_to',
    column_name: 'customer_kind',
    extra: {
      model_name: 'CustomerKind',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_connection_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_connection',
    extra: {
      model_name: 'CustomerConnection',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_connection: {
    column_type: 'belongs_to',
    column_name: 'customer_connection',
    extra: {
      model_name: 'CustomerConnection',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_tags_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'customer_tags',
    extra: {
      model_name: 'CustomerTag',
    },
    model_name: 'Customer',
  },
  customer_tags: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'customer_tags',
    extra: {
      model_name: 'CustomerTag',
    },
    model_name: 'Customer',
  },
  customer_transaction_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_transaction',
    extra: {
      model_name: 'CustomerTransaction',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_transaction: {
    column_type: 'belongs_to',
    column_name: 'customer_transaction',
    extra: {
      model_name: 'CustomerTransaction',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_business_models_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'customer_business_models',
    extra: {
      model_name: 'CustomerBusinessModel',
    },
    model_name: 'Customer',
  },
  customer_business_models: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'customer_business_models',
    extra: {
      model_name: 'CustomerBusinessModel',
    },
    model_name: 'Customer',
  },
  product_styles_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'product_styles',
    extra: {
      model_name: 'ProductStyle',
    },
    model_name: 'Customer',
  },
  product_styles: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'product_styles',
    extra: {
      model_name: 'ProductStyle',
    },
    model_name: 'Customer',
  },
  sale_channels_id_eq: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'sale_channels',
    extra: {
      model_name: 'SaleChannel',
    },
    model_name: 'Customer',
  },
  sale_channels: {
    column_type: 'has_and_belongs_to_many',
    column_name: 'sale_channels',
    extra: {
      model_name: 'SaleChannel',
    },
    model_name: 'Customer',
  },
  need_supplement_information: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'needSupplementInformation',
  },
  need_follow: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'needFollow',
  },
  pending_approve: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'pendingApprove',
  },
  trade_heat_eq: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'tradeHeatEq',
  },
  order_by_last_follow_record_followed_at: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLastFollowRecordFollowedAt',
  },
  order_by_last_follow_record_of_user_followed_at: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLastFollowRecordOfUserFollowedAt',
  },
  order_by_rest_amount: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByRestAmount',
  },
  order_by_last_traded_at: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLastTradedAt',
  },
  order_by_last_7_day_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLast7DayOrderQty',
  },
  order_by_last_7_day_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLast7DayOrderAmount',
  },
  order_by_last_30_day_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLast30DayOrderQty',
  },
  order_by_last_30_day_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLast30DayOrderAmount',
  },
  order_by_last_month_order_qty: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLastMonthOrderQty',
  },
  order_by_last_month_order_amount: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'orderByLastMonthOrderAmount',
  },
  create_date_eq: {
    column_type: 'date',
    model_name: 'Customer',
    column_name: 'createDate',
  },
  orders_count_eq: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'ordersCountEq',
  },
  related: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'related',
  },
  create_date_gteq: {
    column_type: 'date',
    model_name: 'Customer',
    column_name: 'createDate',
  },
  create_date_lteq: {
    column_type: 'date',
    model_name: 'Customer',
    column_name: 'createDate',
  },
  related_between: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'relatedBetween',
  },
  new_between: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'newBetween',
  },
  no_contact_info: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'noContactInfo',
  },
  taggings_tag_id_eq: {
    column_type: 'belongs_to',
    column_name: 'tag',
    extra: {
      model_name: 'ActsAsTaggableOn::Tag',
      value_column: 'id',
    },
    model_name: 'ActsAsTaggableOn::Tagging',
  },
  tag: {
    column_type: 'belongs_to',
    column_name: 'tag',
    extra: {
      model_name: 'ActsAsTaggableOn::Tag',
      value_column: 'id',
    },
    model_name: 'ActsAsTaggableOn::Tagging',
  },
  new_customer_in_current_year_eq: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'newCustomerInCurrentYearEq',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'manager': { required: false, disabledUpdate: false },
    'phone': { required: false, disabledUpdate: false },
    'customer_level_id': { required: false, disabledUpdate: false },
    'customer_level_fixed': { required: false, disabledUpdate: false },
    'customer_source_id': { required: false, disabledUpdate: false },
    'customer_kind_id': { required: false, disabledUpdate: false },
    'customer_connection_id': { required: false, disabledUpdate: false },
    'customer_tag_ids': { required: false, disabledUpdate: false },
    'customer_transaction_id': { required: false, disabledUpdate: false },
    'customer_business_model_ids': { required: false, disabledUpdate: false },
    'product_style_ids': { required: false, disabledUpdate: false },
    'sale_channel_ids': { required: false, disabledUpdate: false },
    'address': { required: false, disabledUpdate: false },
    'wechat': { required: false, disabledUpdate: false },
    'has_production_capacity': { required: false, disabledUpdate: false },
    'has_design_capability': { required: false, disabledUpdate: false },
    'price_preference': { required: false, disabledUpdate: false },
    'inquiry_content': { required: false, disabledUpdate: false },
    'brand': { required: false, disabledUpdate: false },
    'sales_ability': { required: false, disabledUpdate: false },
    'user_id': { required: false, disabledUpdate: false },
    'customer_jushuitan_order_relations': { required: false, disabledUpdate: false },
    'files': { required: false, disabledUpdate: false },
    'negotiation_form': { required: false, disabledUpdate: false },
    'annual_status_list': { required: false, disabledUpdate: false },
    'new_customer_in_current_year': { required: false, disabledUpdate: false },
  },
  'customer_jushuitan_order_relations': {
    'id': { required: false, disabledUpdate: true },
    'jushuitan_order_foreign_key': { required: true, disabledUpdate: true },
    'jushuitan_order_foreign_key_value': { required: true, disabledUpdate: true },
    '_destroy': { required: false, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Customer', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Customer', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
